import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'type'
})
export class TypePipe implements PipeTransform {

  transform(file: string, ...args: unknown[]): string {
    let type = 'image';
    if (file.split('.').pop()?.toLowerCase() == 'png' || file.split('.').pop()?.toLowerCase() == 'jpg' || file.split('.').pop()?.toLowerCase() == 'jpeg' || file.split('.').pop()?.toLowerCase() == 'webp' || file.split('.').pop()?.toLowerCase() == 'bmp' || file.split('.').pop()?.toLowerCase() == 'tif' || file.split('.').pop()?.toLowerCase() == 'gif' || file.split('.').pop()?.toLowerCase() == 'heic') {
      type = 'image';
    } else if (file.split('.').pop()?.toLowerCase() == 'pdf') {
      type = 'pdf'
    } else if (file.split('.').pop()?.toLowerCase() == 'mp3' || file.split('.').pop()?.toLowerCase() == 'mp4' || file.split('.').pop()?.toLowerCase() == 'mov') {
      type = 'video'
    } else if (file.split('.').pop()?.toLowerCase() == 'flv') {
      type = 'none'
    }

    return type;
  }

}
